import { render } from "./AdditionalUploadingTemplate.vue?vue&type=template&id=1cc63ee8&scoped=true&ts=true"
import script from "./AdditionalUploadingTemplate.vue?vue&type=script&lang=ts"
export * from "./AdditionalUploadingTemplate.vue?vue&type=script&lang=ts"

import "./AdditionalUploadingTemplate.vue?vue&type=style&index=0&id=1cc63ee8&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc63ee8"]])

export default __exports__